import React from "react";
import { Outlet } from "react-router-dom";
import Sidebar from "../components/Sidebar";
import ToastContainer from "../components/toast/ToastContainer";
import "./DashboardLayout.css";

const DashboardLayout = () => {
  return (
    <div className="dashboard-container">
      <Sidebar />
      <main className="dashboard-main">
        <Outlet /> {/* Aquí se cargan las páginas dinámicas */}
      </main>
      <ToastContainer />
    </div>
  );
};

export default DashboardLayout;
